module.exports = __webpack_public_path__ + "media/images/icons/facilities/fohn-32d1e0acf8b12ba13b3850d8b73eadaf.svg";